import React from 'react';

/**
 * FindingsBarChart - horizontal bars for the top finding categories. Phase 9.
 *
 * @param {object} props
 * @param {Array<{type:string,count:number}>} props.items
 */
export default function FindingsBarChart({ items = [] }) {
  if (!items.length) {
    return (
      <p className="text-xs text-slate-400 text-center py-6">
        No findings recorded yet.
      </p>
    );
  }
  const max = Math.max(...items.map(i => i.count), 1);
  return (
    <div className="space-y-3">
      {items.map((it) => (
        <div key={it.type}>
          <div className="flex items-center justify-between text-xs mb-1">
            <span className="text-slate-700 font-medium">
              {String(it.type).replace(/_/g, ' ')}
            </span>
            <span className="text-slate-500 font-mono">{it.count}</span>
          </div>
          <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-brand rounded-full transition-all"
              style={{ width: `${(it.count / max) * 100}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
